/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * @author Satyaki Bose
 * @file settingsSelectFieldStyles.js
 */

import { styled } from '@mui/material/styles';
import mixins from '../../../../assets/styles/mixins.scss';
import { quickScheduleFormFieldLabelStyles } from '../../../QuickSchedule/quickScheduleFormConstants';
import getSettingsSelectShellStyles from './settingsSelectSharedStyles';
import { createScopedClasses, createScopedStyles } from '../../../../assets/styles/createScopedStyles';

export const getSettingsSelectMenuProps = (menuPaperClassName, extraMenuProps = {}) => ({
  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
  transformOrigin: { vertical: 'top', horizontal: 'left' },
  ...extraMenuProps,
  PaperProps: {
    className: menuPaperClassName,
    ...(extraMenuProps.PaperProps || {})
  }
});

const settingsSelectFieldStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
    minWidth: 0
  },
  label: {
    ...quickScheduleFormFieldLabelStyles(mixins),
    paddingBottom: 4
  },
  ...getSettingsSelectShellStyles(),
  menuPaper: {
    boxShadow: mixins.paperElevation8BoxShadow,
    '--Paper-shadow': mixins.paperElevation8BoxShadow,
    ...getSettingsSelectShellStyles().menuPaper
  }
};

export const classes = createScopedClasses('aet-settings-select-field', settingsSelectFieldStyles);

export const scopedStyles = createScopedStyles(settingsSelectFieldStyles, classes);

export const SettingsSelectFieldStylesRoot = styled('div')(scopedStyles);

export default settingsSelectFieldStyles;
